import {
  ChangeDetectorRef,
  Component,
  inject,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { TemplatePortal } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { faGear } from '@fortawesome/free-solid-svg-icons';

import { PortalRegistryService } from 'src/app/core/services/portal-registry.service';

import { FormEditorDialogBase } from 'src/app/shared/abstract/form-editor-dialog-base';

import { NomObjectClass } from 'src/app/core/constants';
import { getIconForDataObject } from 'src/app/shared/utils/object-utils';
import { Company, CompanyFeature } from 'src/app/core/models/core.models';

interface DialogData {
  company: Company | null;
  companyFeatures: CompanyFeature[];
}
interface DialogOutput {}

@Component({
  selector: 'app-editor-company-dialog',
  templateUrl: './editor-company-dialog.component.html',
  styleUrl: './editor-company-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditorCompanyDialogComponent extends FormEditorDialogBase<
  any,
  DialogData,
  DialogOutput
> {
  @ViewChild('editorCompany')
  protected override editorComponent!: any;

  private cdr = inject(ChangeDetectorRef);
  private translateService = inject(TranslateService);
  private portalRegistry = inject(PortalRegistryService);

  public tabsPortal!: TemplatePortal;
  public formPortal!: TemplatePortal;

  actionIcon = faGear;
  actionTitle = this.translateService.instant(
    'popup.action-title.add-new-company',
  );
  objectIcon = getIconForDataObject(NomObjectClass.COMPANY);
  objectTitle = this.translateService.instant('popup.object-title.untitled');

  get company() {
    return this.dialogData.company as Company | null;
  }

  get companyFeatures() {
    return this.dialogData.companyFeatures as CompanyFeature[];
  }

  setupUiState(): void {
    if (this.company) {
      this.actionTitle = this.translateService.instant(
        'popup.action-title.edit-company-settings',
      );
      this.objectTitle = this.company.company_name;
    }
  }

  ngOnInit(): void {
    this.setupUiState();
  }

  ngAfterViewInit(): void {
    this.tabsPortal = this.portalRegistry.get('general-form-editor-tabs');
    this.formPortal = this.portalRegistry.get('general-form-editor-form');

    // ! Setup dirty-close protection
    this.initializeFormEditorProtection();

    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.portalRegistry.clearAll();
  }

  onTitleChange(title: string): void {
    this.objectTitle = title;
  }

  async cancelAction(): Promise<void> {
    await this.cancel();
  }
}
